
import { Link, useNavigate, useMatch, useResolvedPath } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandFist, faHome, faWallet, faScrewdriverWrench, faAddressCard } from "@fortawesome/free-solid-svg-icons";
import { faArrowRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import Flag from 'react-world-flags';
import { faUserPlus } from "@fortawesome/free-solid-svg-icons/faUserPlus";

function MainNavigation(props) {
    const navigate = useNavigate();
    
    const loginHanlder = () => {
        navigate("/login");
    };

    const bra = <Flag code="bra" height="15" />;
    const eua = <Flag code="usa" height="13" />;

    return <nav className="mainNavigation">
        <Link to="/" className="site-title"><FontAwesomeIcon icon={faHandFist} />&nbsp;Investidor Libertário</Link>
        <ul>
            <CustomLink to="/">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faHome} />&nbsp;Início&nbsp;</CustomLink>
            {props.isLoggedIn && <CustomLink to="/acoes">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{bra}&nbsp;Ações&nbsp;</CustomLink>}
            {props.isLoggedIn && <CustomLink to="/fiis">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{bra}&nbsp;FIIs&nbsp;</CustomLink>}
            {props.isLoggedIn && <CustomLink to="/stocks">&nbsp;&nbsp;&nbsp;&nbsp;{eua}&nbsp;Stocks&nbsp;</CustomLink>}
            {props.isLoggedIn && <CustomLink to="/etfs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{eua}&nbsp;ETFs&nbsp;</CustomLink>}
            {props.isLoggedIn && <CustomLink to="/reits">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{eua}&nbsp;REITs&nbsp;</CustomLink>}
            {props.isLoggedIn && <CustomIconLink to="/tools">&nbsp;&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faScrewdriverWrench} /></CustomIconLink>}
            {props.isLoggedIn && <CustomLink className="danger" to="/carteira">&nbsp;&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faWallet} />&nbsp;Carteira&nbsp;</CustomLink>}
            {!props.isLoggedIn && <CustomIconLink className="danger" to="/cadastro">&nbsp;&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faUserPlus} /></CustomIconLink>}
            {props.isLoggedIn && <CustomIconLink className="danger" to="/perfil">&nbsp;&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faAddressCard} /></CustomIconLink>}
            {!props.isLoggedIn && <Button variant="success" onClick={loginHanlder}>&nbsp;&nbsp;<FontAwesomeIcon icon={faArrowRightToBracket} />&nbsp;Login&nbsp;</Button>}
            {props.isLoggedIn && <Button variant="danger" onClick={props.onLogout}>&nbsp;<FontAwesomeIcon icon={faArrowRightToBracket} />&nbsp;Logout&nbsp;</Button>}
        </ul>
    </nav>
}

export default MainNavigation;

function CustomIconLink({ to, children, ...props }) {
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({ path: resolvedPath.pathname, end: true })
    return (
        <li className={isActive ? "active onlyIcon" + (props.className ? " "+ props.className : "") : "onlyIcon"+ (props.className ? " "+ props.className : "")}>
            <Link to={to} {...props}>{children}</Link>
        </li>
    )
}

function CustomLink({ to, children, ...props }) {
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({ path: resolvedPath.pathname, end: true })
    return (
        <li className={isActive ? "active" + (props.className ? " "+ props.className : "") : ""+ (props.className ? " "+ props.className : "") }>
            <Link to={to} {...props}>{children}</Link>
        </li>
    )
}